angular.module('jv.Hire.Broadcast.Service',[])
    .service('jvHireBroadcastSVC', ['$rootScope', function($rootScope){
        $rootScope.broadcastEventListeners = $rootScope.broadcastEventListeners || {};

        this.subscribe = function(eventTitle, eventListener){
            if(angular.isUndefined($rootScope.broadcastEventListeners[eventTitle])){
                $rootScope.broadcastEventListeners[eventTitle] = $rootScope.$on(eventTitle, eventListener);
            }
        };

        this.unSubscribe = function(eventTitle){
            if(angular.isDefined($rootScope.broadcastEventListeners[eventTitle])){
                if(angular.isFunction($rootScope.broadcastEventListeners[eventTitle])){
                    $rootScope.broadcastEventListeners[eventTitle]();
                }
            }
        };

        this.destroyAll = function(){
            angular.forEach($rootScope.broadcastEventListeners, function(unRegister){
                unRegister();
            });
            $rootScope.broadcastEventListeners = {};
        };

        this.getEvents = function(){
            return $rootScope.broadcastEventListeners;
        };
    }]);